import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
const plans = [{
  tag: 'MEGAPACK INCLUSIÓN',
  title: 'Megapack Inclusión Educativa',
  features: ['Más de 600 actividades adaptadas (1° a 6°)', 'BONUS 1: Kit de Regulación Emocional', 'BONUS 2: Tableros Visuales y Apoyos', 'BONUS 3: Atención, Memoria y Foco', 'BONUS 4: Cuaderno de Autonomía', 'BONUS 5: Planificador Docente Inclusivo', '4 BONUS PREMIUM: Juegos, Alimentación, Pausas y Matemática'],
  price: '$19.990',
  oldPrice: '$39.990',
  href: 'https://checkout.aula-mater.online/cart/44935969996845:1',
  image: 'https://cdn.magicpatterns.com/uploads/nQycAgud56za6mHCeuzmKT/mockup_pincipal.png',
  imageClass: 'max-h-44',
  highlighted: false
}, {
  tag: 'INCLUSIÓN + EFEMÉRIDES + ESI',
  title: 'El pack más completo',
  subtitle: 'Con esto completás todo el año escolar',
  features: ['Todo el Megapack Inclusión Educativa', 'Los 5 bonus + 4 bonus premium', 'Pack Efemérides Listas completo', 'Megapack ESI Primaria completo', 'Recursos para todo el año', 'El mayor ahorro'],
  price: '$29.990',
  oldPrice: '$59.990',
  href: 'https://checkout.aula-mater.online/cart/66887821852717:1',
  image: 'https://cdn.magicpatterns.com/uploads/tfLBgNNWX34ExBsMbwekJn/ChatGPT_Image_19_jul_2026,_10_37_48_p.m..png',
  imageClass: 'max-h-44',
  highlighted: true
}];
export function PurchaseSection() {
  return <section id="compra" className="py-8 px-4 bg-black text-white text-center" data-id="element-103" data-mp="1l4hryfmlku1f">
      <div className="max-w-5xl mx-auto" data-id="element-104" data-mp="1pxkrd4e22xpj">
        <h2 className="text-[20px] font-black mb-2 text-[#F9327E]" data-id="element-105" data-mp="1uw4cj2kts5gu">
          Accedé ahora al Megapack Inclusión Educativa
        </h2>

        <p className="text-lg md:text-xl font-medium mb-6 max-w-2xl mx-auto text-gray-300" data-id="element-106" data-mp="1zw9zi5g5h3sl">
          Elegí el plan que mejor se adapte a vos. Pago único · Acceso de por
          vida.
        </p>

        {/* Planes */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-3xl mx-auto items-stretch" data-id="element-107" data-mp="1f6o3z2t1op4j">
          {plans.map((plan, i) => <div key={i} className={`relative flex flex-col rounded-3xl p-6 md:p-7 text-left shadow-2xl border-2 ${plan.highlighted ? 'bg-[#16a34a] border-yellow-400 md:scale-105' : 'bg-gray-900 border-gray-800'}`} data-id="element-108" data-mp="1ovzbil0a9lqb" data-mpi={i}>
              {plan.highlighted && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-400 text-gray-900 text-xs font-black px-4 py-1 rounded-full shadow-lg whitespace-nowrap" data-id="element-109" data-mp="1sxkwyuqvv8c4">
                  ⭐ MÁS ELEGIDO
                </div>}

              <span className={`inline-block self-start text-[10px] md:text-xs font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wide ${plan.highlighted ? 'bg-white/20 text-white' : 'bg-gray-800 text-gray-300'}`} data-id="element-110" data-mp="22wsbhl9ct90t">
                {plan.tag}
              </span>

              <h3 className="text-2xl md:text-3xl font-black mb-1 text-white" data-id="element-111" data-mp="2k64cpbd8wfmm">
                {plan.title}
              </h3>
              {plan.subtitle && <p className="text-sm font-bold text-yellow-300 mb-3" data-id="element-112" data-mp="2afjdblpqz72n">
                  {plan.subtitle}
                </p>}

              <ul className="space-y-2 mb-6 mt-2 flex-grow" data-id="element-113" data-mp="2fd1o7hnbrwda">
                {plan.features.map((f, idx) => <li key={idx} className="flex items-start text-sm md:text-base" data-id="element-114" data-mp="21d0fxh4qdmns" data-mpi={idx}>
                    <CheckIcon className={`w-5 h-5 mr-2 flex-shrink-0 mt-0.5 ${plan.highlighted ? 'text-yellow-300' : 'text-green-500'}`} data-id="element-115" data-mp="1rgnjwclpqwpv" />
                    <span className={plan.highlighted ? 'text-white' : 'text-gray-200'} data-id="element-116" data-mp="1whbl1r3notxt">
                      {f}
                    </span>
                  </li>)}
              </ul>

              {plan.image && <div className="flex justify-center mb-4" data-id="element-117" data-mp="1lrnnosycx1uz">
                  <img src={plan.image} alt={plan.title} className={`w-auto ${plan.imageClass} object-contain drop-shadow-xl rounded-lg`} data-id="element-118" data-mp="1lq2rkywe9av0" />
                </div>}

              <div className="mb-4" data-id="element-119" data-mp="17so1rt28b12i">
                <div className="flex items-center gap-2 mb-1" data-id="element-120" data-mp="17tpbnu7idhin">
                  <span className={`text-lg font-bold line-through ${plan.highlighted ? 'text-white/60' : 'text-gray-500'}`} data-id="element-121" data-mp="130mpw88z3cd0">
                    ARS {plan.oldPrice}
                  </span>
                  <span className="bg-red-600 text-white text-xs font-black px-2.5 py-1 rounded-full" data-id="element-122" data-mp="u2ual43944pm">
                    50% OFF
                  </span>
                </div>
                <span className="text-gray-400 text-sm font-bold align-top mr-1" data-id="element-123" data-mp="k44pz3jz065o">
                  ARS
                </span>
                <span className="text-4xl md:text-5xl font-black text-white" data-id="element-124" data-mp="2vpx247rlrf2o">
                  {plan.price}
                </span>
                <p className={`text-xs mt-1 ${plan.highlighted ? 'text-white/80' : 'text-gray-400'}`} data-id="element-125" data-mp="35omdriswo3ah">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <CTAButton href={plan.href} className={`w-full text-lg md:text-xl py-4 ${plan.highlighted ? '!bg-white !text-gray-900 !shadow-[0_0_20px_rgba(255,255,255,0.3)] !from-white !to-white' : ''}`} data-id="element-126" data-mp="2d0qjekqt6ngv">
                👉 LO QUIERO
              </CTAButton>
            </div>)}
        </div>

        {/* WhatsApp + muestra */}
        <div className="max-w-md mx-auto mt-8" data-id="element-127" data-mp="1u9pnk5kzj81j">
          <CTAButton href="https://wa.me/5491124676057?text=Hola%20te%20hablo%20por%20el%20Megapack%20Inclusión%20Educativa%2C%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion." className="w-full text-lg md:text-xl py-4 mb-4 flex items-center justify-center gap-3 !bg-gradient-to-r !from-[#25D366] !to-[#128C7E] !shadow-[0_0_20px_rgba(37,211,102,0.4)]" data-id="element-128" data-mp="1u8xrktnh78aq">
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" data-id="element-129" data-mp="36cf3fyt55oty">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-130" data-mp="2ionsayjc7hu9" />
            </svg>
            COMPRA POR WHATSAPP
          </CTAButton>

          <a href="https://drive.google.com/file/d/1jE3gP9RSE5yqBp0F_bLe9Jsa2CS6GNta/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-block text-lg font-bold text-yellow-400 hover:text-yellow-300 underline underline-offset-4 mb-4 transition-colors" data-id="element-131" data-mp="je1l83uaf1ph">
            📄 Ver muestra gratis
          </a>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-sm font-bold text-gray-300" data-id="element-132" data-mp="3d0iyr7e8zzl3">
            <span className="flex items-center" data-id="element-133" data-mp="3464aifbqpepu">
              <span className="text-green-500 mr-1" data-id="element-134" data-mp="346w27f27usau">✔</span> para 1° a 6° grado
            </span>
            <span className="flex items-center" data-id="element-135" data-mp="2z8b1lej1y6lv">
              <span className="text-green-500 mr-1" data-id="element-136" data-mp="3vxaamvrgncf4">✔</span> acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-137" data-mp="3rvp4rudcfyef">
              <span className="text-green-500 mr-1" data-id="element-138" data-mp="3rx06zpr54y3f">✔</span> descarga digital
            </span>
          </div>
        </div>
      </div>
    </section>;
}